import { render, staticRenderFns } from "./ChatBatchSend.vue?vue&type=template&id=6ca7401c&scoped=true"
import script from "./ChatBatchSend.vue?vue&type=script&lang=js"
export * from "./ChatBatchSend.vue?vue&type=script&lang=js"
import style0 from "./ChatBatchSend.vue?vue&type=style&index=0&id=6ca7401c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7401c",
  null
  
)

export default component.exports